import script from "./ClientDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDetails.vue?vue&type=script&setup=true&lang=js"

import "./ClientDetails.vue?vue&type=style&index=0&id=2ce66a4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce66a4f"]])

export default __exports__